module.exports = __webpack_public_path__ + "img/img_cq_adress_us@3x.5f186c4a.png";